// extracted by mini-css-extract-plugin
module.exports = {"container":"BurgerIcon_container__1-llB","bar1":"BurgerIcon_bar1__a6biW","bar2":"BurgerIcon_bar2__2igb4","bar3":"BurgerIcon_bar3__3uSNI","change":"BurgerIcon_change__3Hzo2"};